import "jspdf-autotable";

import { fullNameTransform, valueTransform, GetApprovalByPositionName, GetApprovalByPositionCode } from "../../util/ValueTransform";

import { PDFObject } from "react-pdfobject";
import React from "react";
import { dateSignature } from "../../util/DateSignature";
import jsPDF from "jspdf";
import kuLogo from "../../assets/image/logo/ku_logo.jpeg";
import qrCode from "../../assets/image/qrcode/form-example.jpg";
import checkMark from "../../assets/image/checkmark.png";
import sarabunFont from "../../assets/fonts/sarabun/THSarabunNew.ttf";
import sarabunFontMedium from "../../assets/fonts/sarabun/Sarabun-Medium.ttf";
import sarabunLight from "../../assets/fonts/sarabun/Sarabun-Light.ttf";
import sarabunRegular from "../../assets/fonts/sarabun/Sarabun-Regular.ttf";
import { thaiDate } from "../../util/DateObject";
import { thaitext } from "../../util/Thaitext";

const props = {
  "Id": 234,
  "Action": "SUBMITTED",
  "FormTypeId": 4,
  "UserId": 1,
  "Data": {
    "reqTopic": "4_MOVE",
    "form_topic": 1,
    "form_reason": "move สาาขา ",
    "form_new_major": "พีชไร่นา",
    "form_old_major": "โรคพืช"
  },
  "DataUser": {
    "Id": 1,
    "Code": "6310103989",
    "Role": "STUDENT",
    "Email": "veerapong.sr@ku.th",
    "Major": "โรคพืช",
    "Status": "กำลังศึกษาอยู่",
    "Faculty": "เกษตร",
    "ReportTo": {
      "Id": 6,
      "Code": null,
      "Role": "PROFESSOR",
      "Email": "atirach.n@ku.th",
      "Major": "สาขาวิชาพืชสวน",
      "Status": "กำลังศึกษาอยู่",
      "Faculty": "คณะเกษตร",
      "Semester": null,
      "MajorCode": "-",
      "Department": "ภาควิชากีฏวิทยา",
      "LastnameTh": "หนูสีดำ",
      "ReportToId": 6,
      "DateOfBirth": "2022-08-24T04:37:28.304Z",
      "FamilyPhone": "456",
      "FirstnameTh": "อธิราช",
      "LastnameEng": "NOOSIDUM",
      "Phonenumber": "34542352345",
      "ThaiPrename": "นาย",
      "AcademicYear": 10,
      "FirstnameEng": "Atirach",
      "ProfileImage": "",
      "SemesterYear": null,
      "FamilyContact": "นาย เอ บี",
      "PersonalEmail": "fagrarn@ku.ac.th",
      "FamilyRelation": "พี่",
      "DatetimeCreated": "2022-08-24T04:36:48.878Z",
      "DatetimeUpdated": "2022-09-12T12:57:51.065Z",
      "CurrentAddressId": 5,
      "MedicalInformation": "หอบหืด"
    },
    "Semester": "1",
    "UserFile": [],
    "MajorCode": "A19",
    "Department": "วิทยาศาสตร์เกษตร",
    "LastnameTh": "ศรีกองลี",
    "ReportToId": 6,
    "DateOfBirth": "2022-08-17T04:35:41.173Z",
    "FamilyPhone": "098763456",
    "FirstnameTh": "วีรพงษ์",
    "LastnameEng": "SREEKONGLEE",
    "Phonenumber": "089999999",
    "ThaiPrename": null,
    "AcademicYear": 4,
    "FirstnameEng": "Veerapong",
    "SemesterYear": "2565",
    "FamilyContact": "นาย เอ บี",
    "PersonalEmail": "gg@gmail.com",
    "CurrentAddress": {
      "Id": 1,
      "Soi": "-",
      "City": "เมือง",
      "HomeNo": "181",
      "Country": "ไทย",
      "Zipcode": "50000",
      "Province": "เชียงใหม่",
      "VillageNo": "สุเทพ",
      "DatetimeCreated": "2022-08-22T14:40:36.119Z",
      "DatetimeUpdated": "2022-09-26T13:38:06.786Z"
    },
    "FamilyRelation": "พี่",
    "DatetimeCreated": "2022-08-22T14:40:36.119Z",
    "DatetimeUpdated": "2022-09-26T13:38:07.667Z",
    "CurrentAddressId": 1,
    "MedicalInformation": "หอบหืด"
  },
  "DatetimeCreated": "2022-09-28T15:16:58.118Z",
  "DatetimeUpdated": null,
  "FormType": {
    "Id": 4,
    "Name": "แบบฟอร์มการขอย้ายสาขา",
    "DatetimeCreated": "2022-08-22T10:31:24.851Z",
    "Code": "MOVE",
    "DatetimeUpdated": null
  },
  "ApprovalStep": [
    {
      "Id": 549,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 6.35,
        "height": 5
      },
      "Comment": null,
      "DatetimeCreated": "2022-09-28T15:16:58.426Z",
      "DatetimeUpdated": null,
      "Email": "veerapong.sr@ku.th",
      "ApprovalTemplateId": 59,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": null,
      "ApprovalTemplate": {
        "Id": 59,
        "Name": "นิสิต",
        "StepNumber": 0,
        "Email": "",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": null
      }
    },
    {
      "Id": 550,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 4.33,
        "height": 5
      },
      "Comment": "1",
      "DatetimeCreated": "2022-09-28T15:17:01.206Z",
      "DatetimeUpdated": "2022-09-28T15:17:20.253Z",
      "Email": "atirach.n@ku.th",
      "ApprovalTemplateId": 60,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": {
        "Dean": {},
        "Major": {
          "Name": "กีฏวิทยา",
          "Chief": "ผศ.ดร.ชามา อินซอน",
          "Email": "atirach.n@ku.th"
        },
        "Major_NEW": {},
        "Department": {
          "Name": "กีฏวิทยา",
          "Chief": "ผศ.ดร.ชามา อินซอน",
          "Email": "atirach.n@ku.th"
        },
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 60,
        "Name": "อาจารย์ที่ปรึกษา",
        "StepNumber": 1,
        "Email": "",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": null
      }
    },
    {
      "Id": 551,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 5.4,
        "height": 5
      },
      "Comment": "2",
      "DatetimeCreated": "2022-09-28T15:17:22.523Z",
      "DatetimeUpdated": "2022-09-28T15:17:29.807Z",
      "Email": "atirach.n@ku.th",
      "ApprovalTemplateId": 61,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": {
        "Dean": {},
        "Major": {
          "Name": "กีฏวิทยา",
          "Chief": "ผศ.ดร.ชามา อินซอน",
          "Email": "atirach.n@ku.th"
        },
        "Major_NEW": {},
        "Department": {
          "Name": "กีฏวิทยา",
          "Chief": "ผศ.ดร.ชามา อินซอน",
          "Email": "atirach.n@ku.th"
        },
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 61,
        "Name": "หัวหน้าภาคฯ / ประธานบริหาร",
        "StepNumber": 2,
        "Email": "",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": null
      }
    },
    {
      "Id": 552,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 4.28,
        "height": 5
      },
      "Comment": "3",
      "DatetimeCreated": "2022-09-28T15:17:30.376Z",
      "DatetimeUpdated": "2022-09-28T15:17:36.658Z",
      "Email": "atirach.n@ku.th",
      "ApprovalTemplateId": 62,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": {
        "Dean": {},
        "Major": {},
        "Major_NEW": {},
        "Department": {},
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 62,
        "Name": "ประธานบริหารหลักสูตรใหม่",
        "StepNumber": 3,
        "Email": "atirach.n@ku.th",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": null
      }
    },
    {
      "Id": 553,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 5.6,
        "height": 5
      },
      "Comment": "4",
      "DatetimeCreated": "2022-09-28T15:17:37.325Z",
      "DatetimeUpdated": "2022-09-28T15:17:43.778Z",
      "Email": "atirach.n@ku.th",
      "ApprovalTemplateId": 63,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": {
        "Dean": {},
        "Major": {},
        "Major_NEW": {},
        "Department": {},
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 63,
        "Name": "ประธานบริหารหลักสูตร",
        "StepNumber": 4,
        "Email": "atirach.n@ku.th",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": null
      }
    },
    {
      "Id": 554,
      "SignatureImage": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAABkCAYAAACb1S5XAAAH4ElEQVR4Xu2dO6gsRRBAfSKIf0UNxMBVBEFBRRADA9dcUcFU3AeCieAzMlHca2SkVwwF3ZcrPtHASOeigZG/yETcix8MFH+gBoLWkS6p1+zu9PTOr3u6odiZ2Zn+1Jmqru6e2T1xTklj0cBMKvKAyFzkdpGDE2Op2UTrAZB7RBYOilXDUYHT712BRdwicqODgZXY9KvsfOYOLGPhXC4ZvCUC+YdMhv02dbyloR9AYBW6rSD+lGMXmKp/LttnnCiY/76OhUNBH7gCTsvnYrx66rRmALjOgWAbEAphU8GA+FLkBwPjl201jIUDjNddpgfyuexUBcNmjtIvEbnBQZiZz201AwJKr8znWVYR0qRYOMB4zhXwlHwehhQ20nNQ/mUiKH2TUO2fRK409advQPlrEZRuQTSGsE0vsXCA8aTLlD4HnznWNPeUDwwSx3clAJBQ9vsiv7ltgCCdp1g4ldSMzo50rwj7QyZ8/W0ic1cJPrUPCKkXbgiFA0KF63qBsK2CsXBoAMroCw7Kn4ngflD6uSKXOhghEDRExf2o8tUtDQpg150TC+cfk2lblmMjH0BYCbn7FQDKRioRhRFy/ejOiYEzl1ZoGB1rOeSBWwQIELQfCFXQp3LiF8YKFEjo9UmcFwPnlLTspQaWg+K1P2C7KQiKOnaWsHJAsIjsUwycj0UrdxnN3C/b75r9hYMBBCwkJimMykHBMiaXYuB8K1q61mjqGdm+yoGIsQq1DDpqQnKATBKGf/fFwLHBQOzdTOgKjElbRp3y6uAQwmrHjYuKcVMaRSkIoEyiz6hTft33PhyUT+et/cWsLgPv+yPZv1CEEfV7zj0VF9VQiXo6cLAOpv9DBnN+MV/JgccKhEjt11wGHKzFjlvsJbgk3JGOqu+Q7WfNCVNeLuiGiMlVLQcAuDA7t8Qx3yUt5ZjORpNN6jPSnSt4nwLqAgI/75UceNQcbGvqZp82ZHttUzgviCae9iwvW+UM3bCmcHB1ulRAZDYfugE5l98UDn0Qa+akAqfjO6MpHDs7cCB1I0AoqSMNNIHDOIipek0lUusIimbbBA79y77rOB03J6/sm8BhJuBV0/zrZZs+qKSONNAEDv2LDkB/l23W8EvqUANN4LDWwlPwpBKpdQglps+p5CId45Q5tZHBKWF0D0BsEaFuzQ+jT0omq57rOrniQuE0feJmcorsosGhcLASOxsdel0XdZ5MniFKZqX0Z6ORt2X7wcloaMCGhsBZSv3KAtsAkOrgzKROX5t6Hcs2x0rqQQN1cOzAk+qUyc4eoGgRu+D4VsODgLFPdPbYpHyK2gXHH9vw8AfPDJQHAnviX+fW/pJ6nG/qAhhc3XpD/Yjq+J6HEvVxW/Ypo+qpPVkVUweHPubFFlusj+LaT33lr8Vi8siqDg6tZExzKKLPDnTVcqwMaDZhoVb0FfKu6jCqfEPgUGFc1sKJvgs6REP+lkL/EPnEgQSowqM+WcELheODABYy8764WfZZIb3afUdQwUu2fSaAVSIrEWYzkk2xcGIaDExgabTHHU9iX79jX6HzqYnreEGLz4saFE7eS5GXG1wzmlP7hNNmo+eS2cwJ+QJNAW+y1O/k+/tE/D6tzTq1nleqcHYpAkgEMQsRXbnV88f+ayNntStHOLaBWMsrxsLWsk2fmETKHY5CwJ1plAkcII0+TQXO90LiGkeDKahq9GSkglOAQ9+jvw0HkwJnRHemdWlUK5kbMpmKRsImauNlZE1JLXvkDmclVOyDKUktFuYMZyZg7BI7b4bbWYdIY+zvspzh+FbDFM6p/lS7f0m5wpmLavzfVkhmfKNYc4XjR2jJWU1SYWUDJ7GUc+1zdseyb2fDG2Q17Km5WQ4Q7HuraDeZQad/K+QGx3dnSYXOOcM5lMbpD5HTztMii2Ed036l52I5uDOiMx3HZPGwfS5w+GeNm9x9yhQNobQuh+93+w54dQ5wGFjqTyn/KNt3iqwH1GlrRacOx0ZnTM8w0Vm1pp2BM0oZDv0LYfPM6fBAPpcD67PV4lOGc0Y0ob+LkNRSQCjBVOFgIToLgDvDvWXRz1hwKcLxF9CSetwp1Go4LzU4/ngmu34mVcshAGDxLKuB5i5LSsVyAMIMAJZDymagmTqcSYJJpc9ZSUX1IY1JWIxa09jd2mtS0ZOusiyazXMMmbe5trHCwZUxjtEHMiYHZqxujV99f9xEZYBhbJPUuzVNxjMpWA6R2IciF5vK0scspghmTJbjj/qpGwtmgEl+XSbWisbQ5wDAvgVAW94UeTi2UblcNzScpev4rT6Jzla5KHifdgwJ5yOp+N2m8tktlu0DZqg+Zy4Fv+N1/IDBvbFGU5LTQJ+Ww9iFtX4g2DTpiGzXndgXHKyFl5j8VzD42+RHRCYbkQ0JZ5u1lP4lwHl3aTmMXQiRfWs5kmN8V6ylBlAXcGYOCq7MJqxlKXIYcNOUU0QDbcNB+Tyv7FsLo30mMddF6+EaaAsOVkIkpiuVWgMiMaBU4VUqZ6oG9oWDC8NSnhA5z6iVmWSsaFVUHa+BGDi3SnFXiCxE6NitCwMKfUrpV+KZ/H/lNjgonEgLd6WjdlwWluL3J2T2jcjzIm+IlCisBTBksQ0OLsm+V7mruKyfHWtJz1HZbINDJ66vVWzKmF/+w0qAWCwlSvX1F+1ya/QbuDL7I96V7LNcPLkl43pVtn/Gv4XOZNR6AZXZAAAAAElFTkSuQmCC",
      "SignatureDimension": {
        "width": 5.15,
        "height": 5
      },
      "Comment": "5",
      "DatetimeCreated": "2022-09-28T15:17:44.351Z",
      "DatetimeUpdated": "2022-09-28T15:17:50.788Z",
      "Email": "atirach.n@ku.th",
      "ApprovalTemplateId": 64,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": {
        "Dean": {},
        "Major": {},
        "Major_NEW": {},
        "Department": {},
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 64,
        "Name": "เจ้าหน้าที่ฝ่ายการศึกษา",
        "StepNumber": 5,
        "Email": "atirach.n@ku.th",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": "วัชราภรณ์ วงศ์วณิช"
      }
    },
    {
      "Id": 555,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 2.73,
        "height": 5
      },
      "Comment": "6",
      "DatetimeCreated": "2022-09-28T15:17:51.356Z",
      "DatetimeUpdated": "2022-09-28T15:17:59.336Z",
      "Email": "atirach.n@ku.th",
      "ApprovalTemplateId": 65,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": null,
      "ForDev": {
        "Dean": {},
        "Major": {},
        "Major_NEW": {},
        "Department": {},
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 65,
        "Name": "แอดมิน",
        "StepNumber": 6,
        "Email": "atirach.n@ku.th",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": null
      }
    },
    {
      "Id": 556,
      "SignatureImage": "data:image/png;base64,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",
      "SignatureDimension": {
        "width": 2.66,
        "height": 5
      },
      "Comment": "6",
      "DatetimeCreated": "2022-09-28T15:17:51.727Z",
      "DatetimeUpdated": "2022-09-28T15:17:59.906Z",
      "Email": "dean@ku.th",
      "ApprovalTemplateId": 66,
      "FormTransactionId": 234,
      "Action": "APPROVED",
      "Type": null,
      "Topic": "6",
      "ForDev": {
        "Dean": {
          "Name": "คณบดี",
          "Chief": "รศ.ดร.สุดสายสิน แก้วเรือง",
          "Email": "agrskr@ku.ac.th"
        },
        "Major": {},
        "Major_NEW": {},
        "Department": {},
        "Department_NEW": {}
      },
      "ApprovalTemplate": {
        "Id": 66,
        "Name": "คณบดี",
        "StepNumber": 7,
        "Email": "dean@ku.th",
        "DatetimeCreated": "2022-09-05T14:53:55.424Z",
        "DatetimeUpdated": null,
        "FormTypeId": 4,
        "Type": "INTERNAL",
        "Code": null,
        "FullName": "รศ.ดร.สุดสายสิน  แก้วเรือง"
      }
    }
  ]
}

const PreView = () => {
  console.log('PreView')
  const doc = new jsPDF({
    orientation: "p",
    format: "a4",
  });

  doc.addFont(sarabunFont, "Sarabun", "normal");
  doc.addFont(sarabunFontMedium, "Sarabun-Medium", "normal");
  doc.addFont(sarabunRegular, "Sarabun-Regular", "normal");
  doc.addFont(sarabunLight, "Sarabun-Light", "normal");

  doc.setFont("Sarabun-Medium");
  doc.setFontSize(15);
  doc.addImage(
    kuLogo,
    "JPEG",
    doc.internal.pageSize.getWidth() / 2 - 12,
    5,
    25,
    25,
    0,
    "NONE",
    0
  );
  doc.text(
    "มหาวิทยาลัยเกษตรศาสตร์",
    doc.internal.pageSize.getWidth() / 2 - 25,
    40
  );
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(12);
  thaitext(
    doc,
    "ใบคำร้องทั่วไป วิทยาศาสตร์เกษตร",
    doc.internal.pageSize.getWidth() / 2 - 35,
    47
  );

  //Righr QRcode
  doc.addImage(
    qrCode,
    "JPEG",
    doc.internal.pageSize.getWidth() / 2 + 70,
    5,
    30,
    30,
    "qr-code",
    "NONE",
    0
  );
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "ตัวอย่างการเขียนคำร้อง",
    doc.internal.pageSize.getWidth() / 2 + 70,
    40
  );
  //End Right QRcode

  // Contect
  doc.setFontSize(10);
  thaitext(
    doc,
    "วันที่........เดือน..................................พ.ศ.................",
    doc.internal.pageSize.getWidth() / 2 - 35,
    54
  );
  doc.setFontSize(9);
  doc.setFont("Sarabun-Regular");
  thaitext(
    doc,
    `${thaiDate(props?.DatetimeCreated).day}`,
    doc.internal.pageSize.getWidth() / 2 - 27 ,
    53
  );
  thaitext(
    doc,
    `${thaiDate(props?.DatetimeCreated).month}`,
    doc.internal.pageSize.getWidth() / 2 - 5 ,
    53
  );
  thaitext(
    doc,
    `2559`,
    doc.internal.pageSize.getWidth() / 2 + 25 ,
    53
  );


  thaitext(
    doc,
    "เรื่อง.................................................................",
    10,
    65
  );

  doc.setFontSize(9);
  doc.setFont("Sarabun-Regular");
  thaitext(
    doc,
   `${props?.FormType?.Name}`,
    25,
    64
  );


  thaitext(
    doc,
    "เรียน.................................................................",
    10,
    73
  );
  doc.setFontSize(9);
  doc.setFont("Sarabun-Regular");
  thaitext(doc, "(อาจารย์ที่ปรึกษา)", 25, 78);


  thaitext(
    doc,
    `${props.DataUser?.ReportTo?.FirstnameTh} ${props.DataUser?.ReportTo?.LastnameTh}`,
    25,
    72
  );



  doc.setFontSize(9);
  doc.setFont("Sarabun-Regular");
  thaitext(
    doc,
    "ข้าพเจ้า  นาย/นาง/นางสาว................................................................................................เลขประจำตัว.................................. นิสิตปีที่ .............",
    20,
    85
  );

  thaitext(
    doc,
    `${valueTransform(props?.DataUser?.ThaiPrename)} ${props?.DataUser?.FirstnameTh} ${props?.DataUser?.LastnameTh}`,
    72,
    84
  );
  thaitext(
    doc,
    `${props?.DataUser?.Code}`,
    154,
    84
  );
  thaitext(
    doc,
    `${props?.DataUser?.AcademicYear}`,
    191,
    84
  );

  thaitext(
    doc,
    "สาขาวิชาเอก.................................................................................................คณะ.............................................................................................................",
    10,
    92
  );
  thaitext(
    doc,
    `${props?.Data?.form_topic === 1 ? props?.Data?.form_old_department : props?.Data?.form_old_major}`,
    35,
    91
  );
  thaitext(
    doc,
    `${props.DataUser.Faculty}`,
    130,
    91
  );

 

  thaitext(
    doc,
    "ที่อยู่ปัจจุบัน.......................................................................................................................................................................................................................",
    10,
    99
  );

  thaitext(
    doc,
    `${props.DataUser?.CurrentAddress?.HomeNo} ${props.DataUser?.CurrentAddress?.Soi} ต.${props.DataUser?.CurrentAddress?.VillageNo} อ.${props.DataUser?.CurrentAddress?.City} จ.${props.DataUser?.CurrentAddress?.Province} ${props.DataUser?.CurrentAddress?.Country} ${props.DataUser?.CurrentAddress?.Zipcode}`,
    35,
    98
  );

  thaitext(
    doc,
    "โทรศัพท์........................................................................................E-mail.........................................................................................................................",
    10,
    106
  );
  thaitext(
    doc,
    `${props.DataUser?.Phonenumber}`,
    35,
    105
  );
  thaitext(
    doc,
    `${props.DataUser?.Email}`,
    120,
    105
  );


  thaitext(
    doc,
    "ประสงค์ขอย้ายไปเรียน สาขาวิชา/หลักสูตร...........................................เนื่องจาก",
    10,
    113
  );
  thaitext(
    doc,
    `${props.Data.form_topic === 1 ? props.Data?.form_new_major : props.Data?.form_new_department}`,
    75,
    112
  );

  // doc.text(
  //   "ประโยคความซ้อน (สังกรประโยค) หมายถึง ประโยคที่รวมประโยคความเดียว ๑ ประโยคเป็นประโยคหลัก แล้วมีประโยคความเดียวอื่นมาเสริม มีข้อสังเกตคือ ประโยคหลัก (มุขยประโยค) กับ ประโยคย่อย (อนุประโยค) ของประโยคความช้อนมี น้ำหนังไม่เท่ากัน",
  //   10,
  //   119,
  //   { maxWidth: 180 }
  // );

  //
  // var splitTitle = doc.splitTextToSize(
  //   "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheet",
  //   180
  // );
  // doc.text(10, 119, splitTitle);
  //

  thaitext(
    doc,
    "..........................................................................................................................................................................................................................................",
    10,
    120
  );
  thaitext(
    doc,
  `${props.Data?.form_reason}`  ,
    20,
    119
  );

  thaitext(
    doc,
    "...........................................................................................................................................................................................................................................",
    10,
    127
  );

  thaitext(
    doc,
    "...........................................................................................................................................................................................................................................",
    10,
    134
  );

  thaitext(doc, "จึงเรียนมาเพื่อโปรดพิจารณา", 150, 141);
  thaitext(
    doc,
    "ลงนาม....................................................",
    140,
    148
  );
  doc.addImage(
    valueTransform(props.ApprovalStep[0]?.SignatureImage),
    "JPEG",
    167,
    143,
    valueTransform(props.ApprovalStep[0]?.SignatureDimension?.width),
    5,
    "signature-step-4",
    "NONE",
    0
  );
  thaitext(doc, "(                                           )", 150, 155);
  thaitext(doc,`${props.DataUser.FirstnameTh} ${props.DataUser.LastnameTh}`, 158, 155);

  doc.setFont("Sarabun-Light");
  doc.rect(10, 161, 95.25, 43);
  doc.rect(105.25, 161, 95.25, 43);
  doc.rect(10, 204, 95.25, 43);
  doc.rect(105.25, 204, 95.25, 43);
  doc.rect(10, 247, 95.25, 43);
  doc.rect(105.25, 247, 95.25, 43);

  // text in boxes
  // Start box 1
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "1. เรียน ประธานบริหารหลักสูตรฯ",
    15,
    167
  );

  thaitext(doc, "เห็นควรอนุญาต", 30, 180);

  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "ลงนาม/Signature...........................................................",
    30,
    187
  );

  doc.addImage(
    valueTransform(props.ApprovalStep[1]?.SignatureImage),
    "JPEG",
    70,
    182,
    valueTransform(props.ApprovalStep[1]?.SignatureDimension?.width),
    5,
    "signature-step-1-1",
    "NONE",
    0
  );

  thaitext(doc, "(.................................................)", 55, 192);
  thaitext(doc, fullNameTransform(props, "advisor"), 63, 191);
  thaitext(doc, "........./.........../..........", 65, 197);
  thaitext(doc, `${props.ApprovalStep[1] ? dateSignature(props.ApprovalStep[1].DatetimeUpdated ? props.ApprovalStep[1]?.DatetimeUpdated : props.ApprovalStep[1].DatetimeCreated) : ""}`, 65, 196);
  thaitext(doc, "อาจารย์ที่ปรึกษา", 65, 202);
  // End Box 1

  // Start Box 3
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(doc,`4. ${valueTransform(props.ApprovalStep[3]?.ForDev?.AgendaForDean)}`, 110, 166);
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(doc, "เพื่อโปรดพิจารณาอนุมัติ", 140, 176);
  thaitext(
    doc,
    "ลงนาม/Signature...........................................................",
    125,
    187
  );

  doc.addImage(
    valueTransform(GetApprovalByPositionName(props, "ประธานบริหารหลักสูตร")?.SignatureImage),
    "JPEG",
    165,
    182,
    valueTransform(GetApprovalByPositionName(props, "ประธานบริหารหลักสูตร")?.SignatureDimension?.width),
    5,
    "signature-step-1-4",
    "NONE",
    0
  );
  thaitext(
    doc,
    "(.................................................)",
    150,
    192
  );
  thaitext(
    doc,
    valueTransform(`${props.Data.form_topic === 1 ?   GetApprovalByPositionName(props, "ประธานบริหารหลักสูตร")
    ?.ForDev?.Major?.Chief :  GetApprovalByPositionName(props, "ประธานบริหารหลักสูตร")
    ?.ForDev?.Department?.Chief}`),
    156,
    191
  );
  thaitext(doc, "........./.........../..........", 158, 197);
  thaitext(doc, `${props.ApprovalStep[4] ? dateSignature(props.ApprovalStep[4].DatetimeUpdated ? props.ApprovalStep[4]?.DatetimeUpdated : props.ApprovalStep[4].DatetimeCreated) : ""}`, 158, 196);
  thaitext(doc, "ประธานบริหารหลักสูตรฯ", 155, 202);
  // End Box 3

  // Start Box 2
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "2. เรียน หัวหน้าภาควิชา.........................................................................",
    15,
    211
  );

thaitext(
  doc,
  `${props.Data.form_topic === 1 ? props.Data?.form_old_major : props.Data?.form_old_department}`,
  50,
  210
);

  thaitext(doc, "(ภาคฯ/หลักสูตร ที่นิสิตขอย้ายเข้า)", 50, 215);
  thaitext(doc, "เพื่อโปรดพิจารณา", 60, 224.5);
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "ลงนาม/Signature...........................................................",
    30,
    230
  );

  doc.addImage(
    valueTransform(props.ApprovalStep[2]?.SignatureImage),
    "JPEG",
    70,
    226,
    5,
    3,
    "signature-step-1-2 ",
    "NONE",
    0
  );

  thaitext(doc, "(.................................................)", 55, 235);
  thaitext(
    doc,
    valueTransform(
      GetApprovalByPositionCode(props, "chiefSyllabus")
        ?.ForDev?.Major?.Chief
    ),
    62,
    234
  );
  thaitext(doc, "........./.........../..........", 65, 240);
  thaitext(doc, `${props.ApprovalStep[2] ? dateSignature(props.ApprovalStep[2].DatetimeUpdated ? props.ApprovalStep[2]?.DatetimeUpdated : props.ApprovalStep[2].DatetimeCreated) : ""}`, 65, 239);
  thaitext(doc, "หัวหน้าภาคฯ / ประธานบริหารหลักสูตรฯ(เดิม)", 45, 245);
  // End Box 2

  // Start Box 4
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(doc, "5. เรียนคณบดี", 110, 209);
  thaitext(doc, "เพื่อโปรดพิจารณาเสนอที่ประชุม", 132, 215);
  thaitext(doc, "คณะกรรมการคณะเกษตร", 136, 220);
  thaitext(doc, "เพื่อโปรดพิจารณาต่อไป", 137, 225);

  doc.setFont("Sarabun-Light");
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "ลงนาม/Signature...........................................................",
    125,
    230
  );

  thaitext(
    doc,
    valueTransform(`${props.Data.form_topic === 1 ?   GetApprovalByPositionName(props, "ประธานบริหารหลักสูตร")
    ?.ForDev?.Major?.Chief :  GetApprovalByPositionName(props, "ประธานบริหารหลักสูตร")
    ?.ForDev?.Department?.Chief}`),
    156,
    191
  );

  doc.addImage(
    valueTransform(GetApprovalByPositionCode(props, "studyOfficer")?.SignatureImage),
    "JPEG",
    168,
    225,
    valueTransform(GetApprovalByPositionCode(props, "studyOfficer")?.SignatureDimension?.width),
    5,
    "signature-step-1-5",
    "NONE",
    0
  );

  thaitext(
    doc,
    "(.................................................)",
    150,
    235
  );
  thaitext(
    doc,
    valueTransform(
      GetApprovalByPositionCode(props, "studyOfficer")?.ApprovalTemplate.FullName
    ),
    155,
    234
  );
  thaitext(doc, "........./.........../..........", 160, 240);
  thaitext(doc, `${props.ApprovalStep[5] ? dateSignature(props.ApprovalStep[5].DatetimeUpdated ? props.ApprovalStep[5]?.DatetimeUpdated : props.ApprovalStep[5].DatetimeCreated) : ""}`, 160, 239);
  thaitext(doc, "เจ้าหน้าที่ฝ่ายการศึกษา", 157, 245);

  // End Box 4

  // Start Box 7
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "3. เรียน ประธานบริหารหลักสูตรฯ........................................................",
    15,
    252
  );
  thaitext(
    doc,
    `${props.Data.form_topic === 1 ? props.Data?.form_new_major : props.Data?.form_new_department}`,
    65,
    251
  );
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  doc.rect(20, 255, 3, 3);


  thaitext(
    doc,
    "ไม่ขัดข้องและจัดให้................................................................",
    25,
    258
  );
  thaitext(
    doc,
    "รหัส A..................เป็นอาจารย์ที่ปรึกษา",
    25,
    263
  );
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);

  doc.rect(20, 266, 3, 3);

  thaitext(
    doc,
    "ไม่สามารถรับได้",
    25,
    269
  );

  if (GetApprovalByPositionName(props, 'ประธานบริหารหลักสูตรใหม่')?.Action === 'APPROVED') {
    doc.addImage(
      checkMark,
      "PNG",
      20,
      253,
      5,
      5,
      "signature-step-checkmark1",
      "NONE",
      0
    );
  } else if (GetApprovalByPositionName(props, 'ประธานบริหารหลักสูตรใหม่')?.Action === 'REJECTED') {
    doc.addImage(
      checkMark,
      "PNG",
      20,
      264,
      5,
      5,
      "signature-step-checkmark1",
      "NONE",
      0
    );
  }
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(
    doc,
    "ลงนาม/Signature...........................................................",
    30,
    273
  );

  doc.addImage(
    valueTransform(props.ApprovalStep[3]?.SignatureImage),
    "JPEG",
    70,
    268,
    5,
    3,
    "signature-step-1-3 ",
    "NONE",
    0
  );

  thaitext(doc, "(.................................................)", 55, 278);
  thaitext(
    doc,
    valueTransform(`${props.Data.form_topic === 1 ?   GetApprovalByPositionName(props, "ประธานบริหารหลักสูตรใหม่")
    ?.ForDev?.Major?.Chief :  GetApprovalByPositionName(props, "ประธานบริหารหลักสูตรใหม่")
    ?.ForDev?.Department?.Chief}`),
    62,
    277
  );
  thaitext(doc, "........./.........../..........", 65, 283);
  thaitext(doc, `${props.ApprovalStep[3] ? dateSignature(props.ApprovalStep[3].DatetimeUpdated ? props.ApprovalStep[3]?.DatetimeUpdated : props.ApprovalStep[3].DatetimeCreated) : ""}`, 65, 282);
  // End Box 7

  // Start Box 8
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(9);
  thaitext(doc, "6. เรียน เลขานุการคณะกรรมการประจำคณะเกษตร", 110, 252);

  thaitext(doc, "เพื่อโปรดดำเนินการนำเสนอที่ประชุม", 129, 258);
  thaitext(doc, "คณะกรรมการประจำคณะเกษตร", 132, 263);
  thaitext(doc, "พิจารณาให้ความเห็นชอบต่อไป", 133, 268);

  thaitext(
    doc,
    "ลงนาม/Signature...........................................................",
    125,
    273
  );
  doc.addImage(
    valueTransform(GetApprovalByPositionName(props, "คณบดี")?.SignatureImage),
    "JPEG",
    168,
    269,
    valueTransform(GetApprovalByPositionName(props, "คณบดี")?.SignatureDimension?.width),
    5,
    "signature-step-4-6",
    "NONE",
    0
  );
  thaitext(
    doc,
    "(.................................................)",
    150,
    278
  );

  thaitext(
    doc,
    valueTransform(
      GetApprovalByPositionName(props, "คณบดี")?.ApprovalTemplate.FullName
    ),
    155,
    277
  );
  thaitext(doc, "........./.........../..........", 160, 283);
  thaitext(doc, `${props.ApprovalStep[6] ? dateSignature(props.ApprovalStep[6].DatetimeUpdated ? props.ApprovalStep[6]?.DatetimeUpdated : props.ApprovalStep[6].DatetimeCreated) : ""}`, 160, 282);
  thaitext(doc, "คณบดี", 168, 288);


  // doc.output("dataurlnewwindow");
  const url = doc.output("bloburi");

  return <PDFObject height="1000px" style={{ height: "100vh" }} url={url} />;
};

export default PreView;
